import MenuController from './menu_controller'

// Tri d'une liste dans la barre native (SortComponent) : même contrat que le ⋯, sans
// sections, chaque entrée porte `selected` et `visit: 'replace'`.
export default class extends MenuController {
  static component = 'sort'
}
